export const EVENT_TYPES = [
  { value: 'urlaub',        label: 'Urlaub',          color: '#3b82f6' },
  { value: 'krankenheit',   label: 'Krankenheit',      color: '#ef4444' },
  { value: 'feiertag',      label: 'Feiertag',         color: '#10b981' },
  { value: 'workshop',      label: 'Workshop',         color: '#8b5cf6' },
  { value: 'geschaftsreise',label: 'Geschäftsreise',   color: '#f59e0b' },
]

export const EVENT_TYPE_MAP = Object.fromEntries(EVENT_TYPES.map((t) => [t.value, t]))

export function eventColor(eventType) {
  return EVENT_TYPE_MAP[eventType]?.color || '#6b7280'
}
